import { FC, useEffect, useState } from 'react';
import Button from '../../Button';
import moment from 'moment';
import { IStudent } from '../../../models/students.model';
import { Descriptions } from 'antd';
import useAxios from '../../../hooks/useAxios';
import { IGetStudentMemos } from '../../../models/studentsMemos.model';
import { createStudentMemo, getStudentMemos } from '../../../api/studentsMemos.api';
import Loader from '../../Loader';
import ErrorResponse from '../../ErrorResponse';
import useNotification from '../../../hooks/useNotification';
import useAuth from '../../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { StudentContents } from '../../../pages/student/student';

interface IProps {
  student: IStudent|undefined;
  onTabChange(tabIndex: number): void;
}

const StudentMemo: FC<IProps> = ({
  student,
  onTabChange,
}) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetStudentMemos>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [memo, setMemo] = useState('');

  useEffect(() => {
    if (student) {
      doGetStudentMemos();
    }
  }, [student]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      setMemo('');
      doGetStudentMemos();
    }
  }, [submitRes, submitIsLoading]);

  const doGetStudentMemos = () => {
    if (!student) return;
    execute(getStudentMemos(student.campusCode, student.studentCode));
  }

  const onSubmit = () => {
    if (!student) return;
    if (!memo) {
      return infoNotification(t('student.student.message12'));
    }

    submitExecute(createStudentMemo(student.studentCode, {
      campusCode: student.campusCode,
      memo,
    }));
  }

  return (
    <>
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />

      <div className="comm-bx__between">
        <h3 className="sub-title">{t('student.student.tab10')}</h3>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={() => {
              window.scrollTo(0, 0);
              onTabChange(StudentContents.Memo);
            }}
            text={t('student.student.button5')}
          />
        </div>
      </div>
      <div className='comm-table__area rowType'>
        <table>
          <tbody>
            <tr><td>
              <div className="flex">
                <input
                  type="text"
                  className="form-control w-100"
                  placeholder={t('student.student.placeholder3')}
                  value={memo}
                  onChange={(e) => setMemo(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') onSubmit();
                  }}
                />
                <div className="comm-btn__area right ml-2">
                  <Button
                    className="btn-basic small pink"
                    onClick={onSubmit}
                    text={t('common.button.confirm')}
                    writeAuthYn={writeAuthYn}
                  />
                  <Button
                    className="btn-basic small gray"
                    onClick={() => setMemo('')}
                    text={t('common.button.cancel')}
                  />            
                </div>
              </div>
            </td></tr>
          </tbody>
        </table>
        <Descriptions bordered size="small" column={1}>
          {res?.data?.slice(0, 10).map((item: any) => (
            <>
              <Descriptions.Item
                label={`(${moment(item?.regDate).format('YYYY.MM.DD HH:mm:ss')}) ${item?.korName}`}
              >
                {item?.memo}              
              </Descriptions.Item>
            </>
          ))}
        </Descriptions>
      </div>
    </>
  );
};

export default StudentMemo;
